<div [ngClass]="styleClass">
    <p
        *ngIf="progressStatus?.stepStatus"
        [ngClass]="{ 'sera-progress-bar__step__red': progressStatus?.isFailed, 'sera-progress-bar__step': !progressStatus?.isFailed }">
        {{ progressStatus!.stepStatus! }}
    </p>
    <div class="sera-progress-bar__progress-container">
        <p-progressBar
            *ngIf="progressStatus?.isToShowProgress"
            [value]="progressStatus?.value"
            [mode]="mode"
            [showValue]="showValue"
            [styleClass]="styleBar" />
        <p
            *ngIf="progressStatus?.isToShowProgress && progressStatus?.value && mode === 'determinate'"
            class="sera-progress-bar__percentage">
            {{ progressStatus!.value! + '%' }}
        </p>
    </div>
    <div class="sera-progress-bar__description__container">
        <p
            *ngIf="progressStatus?.stepDescription"
            [ngClass]="{ 'sera-progress-bar__description__red': progressStatus?.isFailed, 'sera-progress-bar__description': !progressStatus?.isFailed }">
            {{ progressStatus?.isToShowProgress ? progressStatus!.stepDescription! + '' + statusText : progressStatus?.stepDescription }}
        </p>
        <p
            *ngIf="progressStatus?.stepSecondDescription"
            class="sera-progress-bar__description">
            {{ progressStatus!.stepSecondDescription! }}
        </p>
    </div>
</div>
